import { defineStore } from 'pinia'
import NetworkLogsState, { NetworkLogsStateType } from './state'
import { NetworkLogsActions, NetworkLogsActionsType } from './actions'
import { NetworkLogsGetters } from './getters'

export const useNetworkLogsStore = defineStore<
  'networkLogs',
  NetworkLogsStateType,
  typeof NetworkLogsGetters,
  NetworkLogsActionsType
>('networkLogs', {
  state: NetworkLogsState,
  actions: NetworkLogsActions,
  getters: NetworkLogsGetters,
})
